import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const RefundPage = () => {
  const { t } = useLanguage();
  const c = t('legal.refundContent') || {};

  const sections = [
    { title: c.s1t, text: c.s1 },
    { title: c.s2t, text: c.s2 },
    { title: c.s3t, text: c.s3 },
    { title: c.s4t, text: c.s4 },
    { title: c.s5t, text: c.s5 },
    { title: c.s6t, text: c.s6, hasEmail: true },
    { title: c.s7t, text: c.s7 },
  ];

  return (
    <div className="min-h-screen pt-24" data-testid="refund-page">
      <div className="container-custom py-12 max-w-4xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white mb-8" data-testid="refund-back-link">
          <ArrowLeft className="w-4 h-4" />{t('legal.backToHome')}
        </Link>
        <h1 className="text-4xl font-bold mb-2" data-testid="refund-title">{t('legal.refundTitle')}</h1>
        <p className="text-white/40 text-sm mb-8">{t('legal.lastUpdated')}</p>
        <div className="prose-legal space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-semibold text-[#E8720C] mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed">
                {s.text}
                {s.hasEmail && (
                  <> <a href="mailto:support@ogmusicgroup.com" className="text-[#E8720C] hover:underline">support@ogmusicgroup.com</a>.</>
                )}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RefundPage;
